import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const MONO = { fontFamily: "'JetBrains Mono', monospace" };

const markers = [
  ["07:00", "Cortisol peaks"],
  ["14:00", "Alertness high"],
  ["21:00", "Melatonin rises"],
];

const dot = (hour) => {
  const a = ((hour / 24) * 360 - 90) * (Math.PI / 180);
  return [200 + 140 * Math.cos(a), 200 + 140 * Math.sin(a)];
};

export const CircadianDial = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
  <div ref={ref} data-testid="science-circadian-dial">
    <svg viewBox="0 0 400 400" className="w-full max-w-md mx-auto">
      {Array.from({ length: 24 }).map((_, h) => {
        const a = ((h / 24) * 360 - 90) * (Math.PI / 180);
        const long = h % 6 === 0;
        const r1 = long ? 152 : 158;
        return (
          <line
            key={h}
            x1={200 + r1 * Math.cos(a)}
            y1={200 + r1 * Math.sin(a)}
            x2={200 + 166 * Math.cos(a)}
            y2={200 + 166 * Math.sin(a)}
            stroke={long ? "#6E7178" : "#2A2C30"}
            strokeWidth="1.5"
          />
        );
      })}
      <circle cx="200" cy="200" r="140" fill="none" stroke="#1A1C20" strokeWidth="2" />
      <motion.circle
        cx="200"
        cy="200"
        r="140"
        fill="none"
        stroke="#FF4D0A"
        strokeWidth="2"
        transform="rotate(-90 200 200)"
        initial={{ pathLength: 0 }}
        animate={inView ? { pathLength: 1 } : { pathLength: 0 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
      />
      {[7, 14, 21].map((h) => {
        const [x, y] = dot(h);
        return <circle key={h} cx={x} cy={y} r="5" fill="#FF4D0A" />;
      })}
      <text x="200" y="192" textAnchor="middle" fill="#F2F0EB" fontSize="52" fontWeight="700" style={{ fontFamily: "'Archivo Narrow', sans-serif", letterSpacing: "-1px" }}>
        24H
      </text>
      <text x="200" y="222" textAnchor="middle" fill="#6E7178" letterSpacing="3" style={MONO} className="text-[13px] sm:text-[10px]">
        THE MOLECULAR CLOCK
      </text>
    </svg>
    <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 mt-4">
      {markers.map(([t, l]) => (
        <span key={t} className="inline-flex items-center gap-2 font-mono-brand text-[10px] tracking-[0.18em] uppercase text-[#9DA1A8]">
          <span className="w-1.5 h-1.5 bg-[#FF4D0A] inline-block" />
          {t} {l}
        </span>
      ))}
    </div>
  </div>
  );
};
